<div class="print-container">
    <h1 class="page-label">Portal Validation - Enter Info</h1>
    <h4 class="page-label">Selected Portal: {{ portal?.name }}</h4>
</div>

<div class="print-container">
    <div>
        <div class="row">
            <label class="col-sm-5 input-label" for="po-number-input">PO/PP Number:</label>
            <input [(ngModel)]="orderNumber" class="col-sm-7 form-control" id="po-number-input" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled">
        </div>
        <div class="row">
            <label class="col-sm-5 input-label" for="transport-id-input">TransID (Container ID):</label>
            <input [(ngModel)]="transportId" class="col-sm-7 form-control" id="transport-id-input" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled">
        </div>
        <div class="row">
            <label class="col-sm-5 input-label" for="bol-input">Bill of Lading:</label>
            <input [(ngModel)]="billOfLading" class="col-sm-7 form-control" id="bol-input" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled">
        </div>
        <div class="row">
            <label class="col-sm-5 input-label" for="vendor-invoice-input">Vendor Invoice:</label>
            <input [(ngModel)]="vendorInvoiceNumber" class="col-sm-7 form-control" id="vendor-invoice-input" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled">
        </div>
        <div class="row">
            <label class="col-sm-5 input-label" for="inbound-delivery-input">Inbound Delivery (ASN):</label>
            <input [(ngModel)]="inboundDelivery" class="col-sm-7 form-control" id="inbound-delivery-input" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled">
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onGetInfoClicked()" class="submit btn btn-primary col-sm-8" [disabled]="isUiDisabled">Get Info</button>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>